<template>
  <model-form
    ref="modelForm"
    :model="location"
    modal-type="modal"
  >
    <div class="column">
      <div class="row q-col-gutter-sm items-center">
        <model-form-input
          field="name"
          class="col-6"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          autofocus
          :disable="!$isPermitted($permissions.HardwareAndRegisterStation.Manage)"
        />
        <q-select
          v-model="location.locationGroup"
          class="col-6"
          label="Location Group"
          :options="locationGroups.data"
          option-label="name"
          clearable
          bottom-slots
          :rules="[val => !!val || 'Field is required']"
          :disable="!$isPermitted($permissions.HardwareAndRegisterStation.Manage)"
        />
        <q-select
          v-model="location.printerSource"
          class="col-6"
          label="Printer Source"
          :options="$mh.asOptions(PRINTER_SOURCE_TYPES.ALL)"
          map-options
          emit-value
          bottom-slots
          :rules="[val => !!val || 'Field is required']"
        />
        <q-select
          v-if="location.printerSource === PRINTER_SOURCE_TYPES.HARDWARE"
          v-model="location.printer"
          class="col-6"
          label="Printer"
          :options="hardwares.data"
          option-label="name"
          clearable
          bottom-slots
        />
        <q-select
          v-else-if="location.printerSource === PRINTER_SOURCE_TYPES.REGISTER"
          v-model="location.registerStation"
          class="col-6"
          label="Register"
          :options="$_.filter(registerStations.data, 'isUnarchived')"
          option-label="name"
          bottom-slots
          clearable
        />
        <q-select
          v-else-if="location.printerSource === PRINTER_SOURCE_TYPES.KITCHEN_DISPLAY"
          v-model="location.kitchenDisplay"
          class="col-6"
          label="Kitchen Display"
          :options="$_.filter(kitchenDisplays.data, 'isUnarchived')"
          option-label="name"
          bottom-slots
          clearable
        />
        <template v-if="$isPermitted($permissions.HardwareAndRegisterStation.Manage)">
          <q-checkbox
            v-model="location.disableAutoPickPrepPrinting"
            class="col-12"
            label="Disable Auto Prep Printing"
          />
          <q-checkbox
            v-model="location.deliverFastPrepItemsToLocalRegisters"
            class="col-12"
            label="Deliver Fast Prep Items To Local Registers"
          />
          <q-checkbox
            v-model="location.deliverReadyToServeItemsToRemoteRegisters"
            class="col-12"
            label="Deliver Ready To Serve Items To Remote Registers"
          />
          <q-checkbox
            v-model="location.deliverFastPrepItemsToRemoteRegisters"
            class="col-12"
            label="Deliver Fast Prep Items To Remote Registers"
          />
        </template>
      </div>
    </div>
  </model-form>
</template>

<script>
import { PRINTER_SOURCE_TYPES } from 'src/models/location/Location'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'LocationForm',
  components: {
    ModelForm
  },
  configuration: ['kitchenDisplays', 'locationGroups', 'registerStations'],
  models: {
    location: {
      printer: {
        fields: ['id', 'name']
      },
      kitchenDisplay: {
        fields: ['id', 'name']
      },
      registerStation: {
        fields: ['id', 'name']
      },
      locationGroup: true
    },
    hardwares: {
      fields: ['id', 'name']
    }
  },
  created () {
    _.extend(this, { PRINTER_SOURCE_TYPES })
  }
}

</script>
